export default __webpack_public_path__ + "static/private-tools-3d5e47fbfaca89506933670d88e9c5bd.png";